module.exports = __webpack_public_path__ + "img/2560493.png";